<template>
    <div class="tooltip_container">
        <div v-if="this.direction === 'top'" v-tooltip.top="`${message}`">
            <slot></slot>
        </div>
        <div v-if="this.direction === 'right'" v-tooltip.right="`${message}`">
            <slot></slot>
        </div>
        <div v-if="this.direction === 'bottom'" v-tooltip.bottom="`${message}`">
            <slot></slot>
        </div>
        <div v-if="this.direction === 'left'" v-tooltip.left="`${message}`">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        direction: {
            type: String,
            default: 'left',
        },
        message: {
            type: String,
            default: ''
        }
    },
}
</script>

<style scoped lang="sass">
.tooltip_container
    width: fit-content
</style>

<style lang="sass">
.tooltip
    font-size: 1.3rem
    line-height: 1.2
    z-index: 1000
    .tooltip-inner
        display: block
        background: rgb(255,255,255)
        color: $grayColor
        border-radius: 8px
        padding: 5px 10px
        border: 2px $mainColor solid
        margin: 16px
.tooltip[aria-hidden='true']
    visibility: hidden
    opacity: 0
    transition: opacity .15s, visibility .15s
.tooltip[aria-hidden='false']
    visibility: visible
    opacity: 1
    transition: opacity .15s
</style>